import { OrgEntity } from "../types/org"

// "87bea959-8753-4ec6-a962-c3f34bb9c44c" // Noa

// "446bff8a-d2d0-4fec-8ff1-585c19800e7d" // cloudbike
// "8fe01761-1a2f-4e9a-854f-557233fa48ad" // new haven
// "d6c2b7fe-d9a6-4afc-9bfc-5ef1bf589129" // new rochelle
// "e29ad11f-0832-4347-8ead-f7f35a5b6d49" // zalando
// "cfe2ac55-346b-4d7d-9023-3f9831839e45" // yale university
// "8eb3f270-af07-4da1-aec5-cb44336b3371" // moovas tribe
// "0db2b98d-c37a-4f87-ab20-7036e4d5bd88" // linkedin
// "773878e4-9419-41f1-ac2b-f4832c2dcffa" // facebook
// "c1cb95ad-e4cc-46ca-bf4f-2578b999dd14" // ltls

// "e244f6fc-37a5-4eff-95fb-7c6516d73895" // google root org
// "87d12b17-628a-425d-8070-4898f4d395be" // google rev 5
// "ac0f568d-cadd-47bd-9762-d5e56e5fd19d" // google rev 6
// "f5861315-72af-4719-8f2c-5388f6689700" // google security
// "5e059703-0d25-4fb2-8735-ca482d652136" // google vans

// "db99c454-06cf-4f5e-83b4-e2366e514e32" // apple
// "097d202e-cb9e-4237-9041-ff134c5b929c" // apple snd

export const NOA_ORG = "87bea959-8753-4ec6-a962-c3f34bb9c44c"

export const ORGS_IS_NOA = (orgs: OrgEntity[]) => {
  const check = (org: OrgEntity) => [NOA_ORG].map((e) => e.toUpperCase()).includes(org.uuid.toUpperCase())
  return orgs.some(check)
}

export const ORGS_IS_GOOGLE = (orgs: OrgEntity[]) => {
  const check = (org: OrgEntity) =>
    [
      "e244f6fc-37a5-4eff-95fb-7c6516d73895", // google root org
      "87d12b17-628a-425d-8070-4898f4d395be", // google rev 5
      "ac0f568d-cadd-47bd-9762-d5e56e5fd19d", // google rev 6
      "f5861315-72af-4719-8f2c-5388f6689700", // google security
      "5e059703-0d25-4fb2-8735-ca482d652136", // google vans
    ]
      .map((e) => e.toUpperCase())
      .includes(org.uuid.toUpperCase())
  return orgs.some(check)
}

export const ORGS_IS_APPLE = (orgs: OrgEntity[]) => {
  const check = (org: OrgEntity) =>
    [
      "db99c454-06cf-4f5e-83b4-e2366e514e32", // apple
      "097d202e-cb9e-4237-9041-ff134c5b929c", // apple snd
    ]
      .map((e) => e.toUpperCase())
      .includes(org.uuid.toUpperCase())
  return orgs.some(check)
}

export const ORGS_HAS_DASHBOARD = (orgs: OrgEntity[]) => {
  const check = (org: OrgEntity) =>
    [
      "e244f6fc-37a5-4eff-95fb-7c6516d73895", // google root org
      "87d12b17-628a-425d-8070-4898f4d395be", // google rev 5
      "ac0f568d-cadd-47bd-9762-d5e56e5fd19d", // google rev 6
      "f5861315-72af-4719-8f2c-5388f6689700", // google security
      "5e059703-0d25-4fb2-8735-ca482d652136", // google vans
      "db99c454-06cf-4f5e-83b4-e2366e514e32", // apple
      "097d202e-cb9e-4237-9041-ff134c5b929c", // apple snd
    ]
      .map((e) => e.toUpperCase())
      .includes(org.uuid.toUpperCase())
  return orgs.some(check)
}

export const APPLE_DATASTUDIO_URL =
  "https://datastudio.google.com/embed/reporting/3f2266e2-0640-447c-839f-d7645258d424/page/1w6sB"
export const GOOGLE_DATASTUDIO_URL =
  "https://datastudio.google.com/embed/reporting/6604bb49-6fba-44d5-8cf6-3689b4dae3a2/page/1w6sB"
